module.exports = __webpack_public_path__ + "media/styles/images/svg/move-gray-ef8d343c5bb6109a29b22ef01c79e28b.svg";